import { render } from "./central-footer.vue?vue&type=template&id=98c4a4d4"
import script from "./central-footer.vue?vue&type=script&lang=js"
export * from "./central-footer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__